import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useApi } from './ApiContext';
import { useWorkspace } from './WorkspaceContext';
import { WhatsNewModal } from '~/components';
import { useMember } from './MemberContext';

const WhatsNewContext = createContext();

const WhatsNewProvider = ({ children }) => {
  const api = useApi();
  const { workspace } = useWorkspace();
  const { member } = useMember();
  const [showWhatsNewModal, setShowWhatsNewModal] = useState(false);
  const [whatsNewEntries, setWhatsNewEntries] = useState([]);

  const fetchWhatsNewEntries = useCallback(async () => {
    if (!workspace?.id) return null;

    try {
      const { data } = await api.www.workspaces(workspace.id).productUpdates().get();
      setWhatsNewEntries(data);

      return data;
    } catch (error) {
      return null;
    }
  }, [api, workspace?.id]);

  useEffect(() => {
    fetchWhatsNewEntries();
  }, [fetchWhatsNewEntries]);

  const handleCloseWhatsNewModal = async () => {
    try {
      setShowWhatsNewModal(false);
      await api.www.workspaces(workspace.id).members().setWhatsNewLastSeen();
    } catch {
      // Do nothing
    }
  };

  const openWhatsNewModal = useCallback(async () => {
    if (sessionStorage.getItem('whats_new_modal') === 'true') return;
    sessionStorage.setItem('whats_new_modal', 'true');
    if (!member?.showWhatsNewModal) return;
    const whatsNewEntries = await fetchWhatsNewEntries();

    if (whatsNewEntries.length > 0) {
      setTimeout(() => {
        setShowWhatsNewModal(true);
      }, 500);
    }
  }, [fetchWhatsNewEntries, member?.showWhatsNewModal]);

  const values = useMemo(() => {
    return {
      whatsNewEntries,
      openWhatsNewModal,
    };
  }, [whatsNewEntries, openWhatsNewModal]);

  return (
    <WhatsNewContext.Provider value={values}>
      {children}
      {showWhatsNewModal && <WhatsNewModal whatsNewEntries={whatsNewEntries} onClose={handleCloseWhatsNewModal} />}
    </WhatsNewContext.Provider>
  );
};

function useWhatsNew() {
  return useContext(WhatsNewContext);
}

export { WhatsNewContext, useWhatsNew, WhatsNewProvider };
